import { render, staticRenderFns } from "./UpskillCareerLoader.vue?vue&type=template&id=4b7e59c7&scoped=true"
import script from "./UpskillCareerLoader.vue?vue&type=script&lang=ts"
export * from "./UpskillCareerLoader.vue?vue&type=script&lang=ts"
import style0 from "./UpskillCareerLoader.vue?vue&type=style&index=0&id=4b7e59c7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b7e59c7",
  null
  
)

export default component.exports